<template>
  <page>
    <div :load="doInit">
      <v-expansion-panels v-model="panel1" multiple>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <div>
              <v-icon>mdi-filter-variant</v-icon> Date Range
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-card>
              <v-card-text>
                <v-form>
                  <v-container fluid grid-list-sm>
                    <v-layout row wrap>
                      <v-flex xs6>
                        <cal-picker v-model="reportForm.tranDateFrom" :label="labels.tranDateFrom" v-validate="fromDateValidation(reportForm.tranDateTo)" :data-vv-as="labels.tranDateFrom" data-vv-name="tranDateFrom" :error-messages="errors.collect('tranDateFrom')" :min="fromDateMinDate" :max="fromDateMax()"></cal-picker>
                      </v-flex>
                      <v-flex xs6>
                        <cal-picker v-model="reportForm.tranDateTo" :label="labels.tranDateTo" v-validate="toDateValidation(reportForm.tranDateFrom)" :data-vv-as="labels.tranDateTo" data-vv-name="tranDateTo" :error-messages="errors.collect('tranDateTo')" :min="reportForm.tranFromData" :max="today"></cal-picker>
                      </v-flex>
                      <!-- <v-flex xs6>
                        <v-autocomplete :items="prntOptList" v-model="reportForm.prntOpt" :label="labels.prntOpt" item-text="label" item-value="value" data-vv-name="prntOpt" :data-vv-as="labels.prntOpt" :error-messages="errors.collect('prntOpt')"></v-autocomplete>
                      </v-flex> -->
                    </v-layout>
                  </v-container>
                </v-form>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-spacer class="mt-2"></v-spacer>
      <v-expansion-panels v-model="panel2" multiple>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <div>
              <v-icon>mdi-filter-variant</v-icon> Selection Criteria
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-card>
              <v-card-text>
                  <v-container fluid grid-list-sm>
                    <v-layout row wrap>
                      <!-- Direct/RI -->
                      <v-flex xs6>
                        <v-autocomplete :items="driList" v-model="reportForm.dri" :label="labels.dri" item-text="label" item-value="value" data-vv-name="dri" :data-vv-as="labels.dri" :error-messages="errors.collect('dri')"></v-autocomplete>
                      </v-flex>
                      <v-flex xs6></v-flex>
                      <!-- Underwriting Year -->
                      <v-flex xs12 sm12 md12 lg12>
                        <v-text-field readonly v-model="reportForm.uwYr" :label="labels.uwYr" :error-messages="errors.collect('uwYr')"
                        :data-vv-as="labels.uwYr" data-vv-name="uwYr" append-icon="mdi-magnify" @click:append="multiUwYrList = true"></v-text-field>
                      </v-flex>
                      <!-- Business Class -->
                      <v-flex xs12 sm12 md12 lg12>
                        <v-text-field readonly v-model="reportForm.busCls" :label="labels.busCls" :error-messages="errors.collect('busCls')"
                        :data-vv-as="labels.busCls" data-vv-name="busCls" append-icon="mdi-magnify" @click:append="multiBusClsList = true"></v-text-field>
                      </v-flex>
                      <!-- Billing Account -->
                      <v-flex xs12 sm12 md12 lg12>
                        <v-text-field v-model="reportForm.inter" :label="labels.inter" :error-messages="errors.collect('inter')"
                        :data-vv-as="labels.inter" data-vv-name="inter" append-icon="mdi-magnify" @click:append="multiInterList = true" readonly></v-text-field>
                      </v-flex>
                      <!-- Department -->
                      <v-flex xs12 sm12 md12 lg12>
                        <v-text-field readonly v-model="reportForm.dept" :label="labels.dept" :error-messages="errors.collect('dept')"
                        :data-vv-as="labels.dept" data-vv-name="dept" append-icon="mdi-magnify" @click:append="multiDeptList = true"></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-spacer class="mt-2"></v-spacer>
      <v-expansion-panels v-model="panel3" multiple>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <div>
              <v-icon>mdi-sort</v-icon> Sort Order(s)
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-card>
              <v-card-text>
                  <v-container fluid grid-list-sm>
                    <v-layout row wrap>
                      <v-flex xs4>
                        <v-card-title>
                            <div class="body-3">Sort Order By</div>
                          <v-spacer></v-spacer>
                          <v-icon @click="showSortOrderHelpList()">mdi-magnify</v-icon>
                        </v-card-title>
                        <v-card-text>
                          <div v-if="showError" class="small font-weight-300 red--text">Sort Order By field is required.</div>
                        </v-card-text>
                      </v-flex>
                      <v-flex xs8>
                        <!-- <v-data-table ref="premSortOrder" :headers="sortOrderHeader" :items="sortOrder" item-key="text" :no-data-text="noText" hide-default-footer>
                          <template v-slot:item="row">
                            <td width="50px"><v-icon class="phSortIcon">mdi-cursor-move</v-icon></td>
                            <td>{{ row.item.text }}</td>
                            <td>{{ row.item.subTotal ? 'Yes' : 'No' }}</td>
                          </template>
                        </v-data-table> -->
                        <v-data-table
                        :headers="sortOrderHeader"
                        :items="sortOrder"
                        :loading="loading"
                        :no-data-text="noText"
                        hide-default-footer
                        item-key="text"
                        ref="premSortOrder"
                        >
                        <template v-slot:item="row">
                          <tr :active="row.selected" @click="doSelectProp(row.item)" :key="row.item.text">
                            <td width="50px"><v-icon class="phSortIcon">mdi-cursor-move</v-icon></td>
                            <td>{{ row.item.text }}</td>
                            <td>{{ row.item.subTotal ? 'Yes' : 'No' }}</td>
                          </tr>
                        </template>
                        </v-data-table>
                        <p v-if="sortOrder.length > 1" align="center">Hold the icon to arrange the sequence</p>
                      </v-flex>
                    </v-layout>
                  </v-container>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-spacer class="mt-2"></v-spacer>
      <v-spacer class="mt-2"></v-spacer>
      <v-form>
        <v-container fluid grid-list-sm>
          <v-layout row wrap>
            <v-flex lg6 xs12>
            <v-checkbox color="primary" :label="labels.rptParam" v-model="reportForm.rptParam"></v-checkbox>
            <v-btn class="mr-2" color="primary" type="submit" :loading="loading" @click.prevent="doExport">
              <v-icon left dark>mdi-file-export</v-icon>
              {{labels.export}}
            </v-btn>
            <v-btn-toggle dense mandatory v-model="reportForm.format">
              <v-btn text v-for="format in supportedList" :key="format.value" :value="format.value">
                <span>{{format.label}}</span>
                <v-icon :color="format.color">{{format.icon}}</v-icon>
              </v-btn>
            </v-btn-toggle>
          </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </div>
      <!-- Underwriting Year Helplist -->
      <v-dialog v-model="multiUwYrList" width="900px" persistent>
        <multi-uw-yr-help-list :uwYr="reportForm.uwYr" @close="doClose" @doAssign="doAssignUwYr($event)"></multi-uw-yr-help-list>
      </v-dialog>
      <!-- Business Class Helplist -->
      <v-dialog v-model="multiBusClsList" width="900px" persistent>
        <multi-bus-cls-help-list :busCls="reportForm.busCls" @close="doClose" @doAssign="doAssignBusCls($event)"></multi-bus-cls-help-list>
      </v-dialog>
      <!-- Billing Account Helplist -->
      <v-dialog v-model="multiInterList" width="900px" persistent>
        <multi-intermediary-help-list
          :intr="reportForm.inter"
          :intrGrp="intrGrp"
          :listName="'billAcctNoList'"
          helpListTitle="Billing Account Helplist"
          @close="doClose" @doAssign="doAssignInter($event)"></multi-intermediary-help-list>
      </v-dialog>
      <!-- Department Helplist -->
      <v-dialog v-model="multiDeptList" width="900px" persistent>
        <multi-dept-help-list :dept="reportForm.dept" @close="doClose" @doAssign="doAssignDept($event)"></multi-dept-help-list>
      </v-dialog>
      <!-- Sort Order Helplist -->
      <v-dialog v-model="sortOrderList" width="900px" persistent>
        <sort-order-help-list :sort="sortOrder" @close="doClose" @doAssign="doAssignSort($event)"></sort-order-help-list>
      </v-dialog>
  </page>
</template>

<script>
import { extractMenu } from '@/utils/extract'
import { reportFormat } from '@/const/report'
import MessageMixin from '@/mixins/message'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import { checkDateRangeFrom, checkDateRangeTo } from '@/directives/common'
import MultiUwYrHelpList from '@/components/core/common/dialog/MultiUwYrHelpList'
import MultiBusClsHelpList from '@/components/core/common/dialog/MultiBusClsHelpList.vue'
import MultiIntermediaryHelpList from '@/components/core/common/dialog/MultiIntermediaryHelpList.vue'
import MultiDeptHelpList from '@/components/core/common/dialog/MultiDeptHelpList.vue'
import SortOrderHelpList from '@/components/core/common/dialog/SortOrderHelpList.vue'
import { prntOptList, driList } from './index'
import Sortable from 'sortablejs'

export default {
  data() {
    return {
      labels: {
        dateRange: 'Date Ranges',
        tranDateFrom: 'Transaction Date From*',
        tranDateTo: 'Transaction Date To*',
        prntOpt: 'Print Option(s)',
        dri: 'Direct/RI',
        uwYr: 'Underwriting Year(s)',
        busCls: 'Business Class(es)',
        inter: 'Billing Account(s)',
        dept: 'Department(s)',
        sort: 'Sort Order By',
        format: 'Export Format',
        export: 'Export to',
        rptParam: 'Print Runtime Parameters'
      },
      reportForm: {
        tranDateFrom: undefined,
        tranDateTo: new Date(),
        prntOpt: 'B',
        dri: 'B',
        uwYr: 'All',
        busCls: 'All',
        inter: 'All',
        dept: 'All',
        sort: '',
        format: undefined,
        rptParam: true
      },
      // HelpList
      multiUwYrList: false,
      multiBusClsList: false,
      multiInterList: false,
      multiDeptList: false,
      sortOrderList: false,
      // Other
      today: new Date(),
      fromDateMinDate: new Date(2000, 0, 1),
      menu: {},
      supportedFormat: [],
      loading: false,
      prntOptList: [],
      driList: [],
      intrGrp: '10,11,12,13,20',
      showError: false,
      noText: 'Sort Order is Not Selected!',
      sortOrder: [],
      sortOrderHeader: [
        { text: '', value: 'pgIcon', sortable: false },
        { text: 'Sort Order', value: 'text', sortable: false },
        { text: 'Sub Total', value: 'subTotal', sortable: false }
      ],
      panel1: [0],
      panel2: [0],
      panel3: [0],
      panel4: [0]
    }
  },
  computed: {
    rptMenu() {
      return this.$store.state.reports.uwReports.menu
    },
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map(format => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    },
    phNewSortHtml() {
      if (this.sortOrder.length === 0) {
        return ''
      } else {
        return this.$refs['premSortOrder'].$el.firstElementChild.firstElementChild.tBodies[0].rows
      }
    }
  },
  methods: {
    async doInit() {
      try {
        if (this.$store.state.reports.uwReports.menu !== 1) {
          await this.$store.dispatch('uwReportsInit')
        }
        const apiURI = this.rptMenu.initPremAnalysis2
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result
          if (data) {
            this.supportedFormat = data.data.format
            this.menu = extractMenu(result.data._links)
          }
        }
      } catch (err) {
        throw err
      }
    },
    doAssignUwYr(Obj) {
      this.reportForm.uwYr = []
      this.reportForm.uwYr = Obj.finalSelectedItems.toString()
    },
    doAssignBusCls(Obj) {
      this.reportForm.busCls = []
      this.reportForm.busCls = Obj.finalSelectedItems.toString()
    },
    doAssignInter(Obj) {
      this.reportForm.inter = []
      this.reportForm.inter = Obj.finalSelectedItems.toString()
    },
    doAssignDept(Obj) {
      this.reportForm.dept = []
      this.reportForm.dept = Obj.finalSelectedItems.toString()
    },
    async doAssignSort(Obj) {
      this.sortOrder = []
      this.sortOrder = Obj.sort
      var sortOrderHtml = this.$refs['premSortOrder'].$el.firstElementChild.firstElementChild.tBodies[0]
      Sortable.create(sortOrderHtml, {
        group: 'premSortOrder', // group of data
        sort: true, // default allow to sort the table lst
        swapThreshold: 0.65, // the threshold position to swap the element
        delay: 1000, // time in milliseconds to define when the sorting should start
        delayOnTouchOnly: true, // only delay if user is using touch
        handle: '.phSortIcon', // to make this class to handle the sort
        animation: 150 // animation
      })
    },
    doClose() {
      this.multiUwYrList = false
      this.multiBusClsList = false
      this.multiInterList = false
      this.multiDeptList = false
      this.sortOrderList = false
    },
    showSortOrderHelpList() {
      this.sortOrderList = true
      this.showError = false
    },
    doExport() {
      let sortOrders = []
      for (let i in this.sortOrder) {
        sortOrders.push(this.phNewSortHtml[i].children[1].innerHTML + ':' + this.phNewSortHtml[i].children[2].innerHTML)
      }
      this.reportForm.sort = sortOrders.toString()
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if (sortOrders.length > 0) {
            this.showError = false
            if (this.reportForm.format === 'PDF') {
              if (this.reportForm.prntOpt === 'D') {
                this.processExportDetail()
              } else if (this.reportForm.prntOpt === 'S') {
                this.processExportSummary()
              } else {
                this.processExportDetail().then(() => {
                  this.processExportSummary()
                })
              }
            } else {
              this.processExportDetail()
            }
          } else {
            this.showError = true
          }
        }
      })
    },
    async processExportDetail() {
      const apiURI = this.menu.exportDetail
      if (apiURI) {
        try {
          this.loading = true
          await this.$http.post(apiURI, this.reportForm)
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async processExportSummary() {
      const apiURI = this.menu.exportSummary
      if (apiURI) {
        try {
          this.loading = true
          await this.$http.post(apiURI, this.reportForm)
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    fromDateMax() {
      return new Date(2070, 11, 31)
    },
    fromDateValidation(toDate1) {
      if (toDate1) {
        return 'required|checkDateRangeFrom:' + toDate1
      } else {
        return 'required|checkDateRangeFrom'
      }
    },
    toDateValidation(fromDate1) {
      if (fromDate1) {
        return 'required|checkDateRangeTo:' + fromDate1
      } else {
        return 'required|checkDateRangeTo'
      }
    }
  },
  created() {
    this.doInit()
    this.prntOptList = prntOptList
    this.driList = driList
    this.$validator.extend('checkDateRangeFrom', checkDateRangeFrom)
    this.$validator.extend('checkDateRangeTo', checkDateRangeTo)
  },
  watch: {
  },
  mixins: [
    MessageMixin,
    commonAjaxMixin
  ],
  components: {
    MultiUwYrHelpList,
    MultiBusClsHelpList,
    MultiIntermediaryHelpList,
    MultiDeptHelpList,
    SortOrderHelpList

  }
}
</script>
